export class LoadAppConfig {
  public static readonly type = '[AppConfig] Load initial config';
}
